// Wortlaute der Erklärung „Maschinen“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter und Felder stehen so, wie die Maschinenseite sie zeigt (../machine.js).
// Zwillingsdatei: help/materials.js. Was hier geändert wird, gehört fast immer auch dorthin.
export default {
  title: "Maschinen",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    MachineOverview: "Übersicht",
    MachineDetail: "Maschine",
    CustomerDetail: "Kundenpreise",
    PacketDetail: "Paket",
    ProjectDetail: "Projekt",
    ProjectCostsForOne: "Projektkosten",
  },
  // Die Seiten außerhalb des Katalogs, in denen eine Maschine wirkt. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier steht der Maschinenpark Ihres Betriebs. Ein Klick auf eine Zeile öffnet die Maschine.",
    },
    row: {
      text: "Die Zeile zeigt Bezeichnung, Einkaufspreis je Einheit und wann die Maschine zuletzt geändert wurde.",
    },
    create: {
      text: "Neu anlegen bietet beides an: Neue Maschine erstellen öffnet das leere Formular. Es braucht Bezeichnung und Einheit.",
    },
    "kind-filter": {
      text: "Maschinen und Pakete stehen in einer Tabelle, der Filter darüber zeigt nur eines von beiden. Ein Paket bündelt mehrere Maschinen für Projekt und Kunde.",
    },
    head: {
      text: "Der Kopf trägt Symbol und Namen der Maschine. Rechts stehen die Aktionen zu diesem Datensatz.",
    },
    "action-duplicate": {
      text: "Duplizieren öffnet eine neue Maschine mit denselben Angaben und Preisen. Sie ändern nur, was anders ist, und speichern.",
    },
    "action-packet": {
      text: "Paket daraus erstellen legt ein neues Paket an. Diese Maschine steht darin schon als erste Position.",
    },
    tabs: {
      text: "Drei Reiter teilen die Seite auf. Welcher Reiter offen ist, steht in der Adresse der Seite.",
    },
    base: {
      text: "Bezeichnung und Abrechnungseinheit sind die Stammdaten. Sie wählen Stunde oder Tag, darauf bezieht sich der Einkaufspreis.",
    },
    purchase: {
      text: "Der Einkaufspreis gilt je Einheit. Wer bei verschiedenen Lieferanten unterschiedlich viel zahlt, legt mehrere Einkaufspreise mit Bezeichnung an; einer davon ist der Standard. Jeder Preis wählt seine eigene Währung, ein Projekt rechnet nur mit dem Preis in seiner Währung.",
    },
    note: {
      text: "Die Notiz ist für den internen Hinweis. Sie gehört zur Maschine und nicht zu einem einzelnen Projekt.",
    },
    files: {
      text: "In die Dateiablage legen Sie Betriebsanleitungen und Prüfprotokolle. Ein Ablaufdatum färbt sich, sobald es näher kommt.",
    },
    activity: {
      text: "Das Protokoll zeigt, wo diese Maschine verwendet wird, und darunter jede Änderung mit Tag und Person.",
    },
    save: {
      text: "Speichern schreibt alle Reiter auf einmal. Ein Reiter mit einem Fehler wird dabei nach vorn geholt.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: was die Maschine außerhalb des Katalogs bewirkt.
    "customer-price": {
      text: "Für einen Kunden hinterlegen Sie einen eigenen Verkaufspreis. Ein Festpreis darf auch pro Tag gelten, wenn die Maschine pro Stunde kostet.",
    },
    "packet-items": {
      text: "Ein Paket bündelt mehrere Maschinen. Ein Projekt oder ein Kunde übernimmt sie damit in einem Schritt.",
    },
    "project-machines": {
      text: "Im Projekt steht neben dem Einkaufspreis der Verkaufspreis. Kosten und Erlös rechnen die Einsatzzeit jeweils in ihre eigene Einheit um.",
    },
    "project-report": {
      text: "Gebucht wird die Maschine im Reiter Maschinen [[hwr:eines/einer/eines]] [[hwr.gen]], je Gerät mit Geräte-Nummer und Stunden. Ein Tagessatz zählt jeden angefangenen Einsatztag.",
    },
    "project-costs": {
      text: "Die Kostenstruktur des Projekts zeigt, welcher Anteil der Kosten auf Maschinen entfällt. Bewertet wird jeder gebuchte Einsatz mit dem Einkaufspreis, der beim Speichern des Berichts festgeschrieben wurde.",
    },
  },
}
